/**
 * Fleet CC DCRP Recovery API
 * Connected Claims Damaged Container Recovery APIs used for handling recovery data.
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { FileUploadModel } from '../models/fileUploadModel';

@Injectable()
export class FileUploadService {
  protected basePath = environment.ccdcrp_api_base_url;
  public defaultHeaders = new HttpHeaders();

  constructor(protected httpClient: HttpClient) {}

  /**
   * Gets the list of uploaded files for a given case ID.
   *
   * @param caseId The case ID.
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public fileUploadCaseIdUploadedFilesGet(
    caseId: number,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<FileUploadModel>>;
  public fileUploadCaseIdUploadedFilesGet(
    caseId: number,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<FileUploadModel>>>;
  public fileUploadCaseIdUploadedFilesGet(
    caseId: number,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<FileUploadModel>>>;
  public fileUploadCaseIdUploadedFilesGet(
    caseId: number,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (caseId === null || caseId === undefined) {
      throw new Error(
        'Required parameter caseId was null or undefined when calling fileUploadCaseIdUploadedFilesGet.'
      );
    }

    let headers = this.defaultHeaders;
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    return this.httpClient.request<Array<FileUploadModel>>(
      'get',
      `${this.basePath}/file-upload/${encodeURIComponent(String(caseId))}/uploaded-files`,
      {
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}

